var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVodHeartFull = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "31px",
    viewBox: "0 0 33 31",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "vod_heart")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vod_heart",
    transform: "translate(1.000000, 1.000000)",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.88235294
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2117647,0 C19.0117647,0 16.2823529,2.54117647 15.0588235,5.27058824 C13.8352941,2.54117647 11.1058824,0 7.90588235,0 C3.57647059,0 0,3.57647059 0,7.90588235 C0,16.7529412 8.94117647,19.1058824 15.0588235,27.8588235 C20.8,19.1058824 30.1176471,16.4705882 30.1176471,7.90588235 C30.1176471,3.57647059 26.5411765,0 22.2117647,0 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVodHeartFull, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vod_heart_full.1d938ec1.svg";
export { ForwardRef as ReactComponent };